
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  methods: {
    fullscreen(ev) {
      const elem = ev.target;

      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.webkitRequestFullscreen) {
        /* Safari */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        /* IE11 */
        elem.msRequestFullscreen();
      }
    },

    goToEvent: function (ev) {
      const id = this.$route.params.id;
      const evento = this.poi.offers.reduce((e, v) => {
        return v.id == ev ? v : e;
      });
      console.log(ev, id);
      this.$router.navigate('/poi-event/' + id + '/' + encodeURIComponent(JSON.stringify(evento)) + '/');
    },
    goToOtherExperience: function (ev) {
      const id = this.$route.params.id;
      this.$app.views.main.router.navigate('/poi-other-experience/' + id + '/' + ev + '/');
    },
    locateHere: function () {
      const poi = this.poi;
      myApp.setMyDiscoGeolocation([poi.coords.latitude, poi.coords.longitude], poi.caption, poi.id);
    },
    selectImage: function (idx) {
      const sw = this.$app.swiper.get('.poi-website-swiper');
      if (this.poi.video) idx++;
      sw.slideTo(idx);
    },
    getPOI: function () {
      const app = this.$app,
            $ = this.$,
            id = this.$route.params.id,
            self = this;
      myApp.server.get('imc/item/' + id).then(poi => {
        myApp.detailItemType = poi.type;
        poi.web = poi.web.match(/^https?\:\/\//) ? poi.web : poi.web ? 'http://' + poi.web : '';
        poi.fb = poi.fb.match(/^https?\:\/\//) ? poi.fb : poi.fb ? 'http://' + poi.fb : '';
        poi.instagram = poi.instagram.match(/^https?\:\/\//) ? poi.instagram : poi.instagram ? 'http://' + poi.instagram : '';
        poi.img = poi.images[0] || 'static/demo/disco.jpg';
        poi.phone_link = poi.phone ? poi.phone.replace(/\s+/g, '') : '';
        myApp.currentPoi = poi;
        console.log(poi);
        self.$setState({
          poi: poi,
          images: poi.images
        }).then(() => {
          const sw = app.swiper.get('.poi-website-swiper');
          sw.update();

          if (!self.poi.video) {
            sw.autoplay.delay = 500;
            sw.autoplay.start();
          }

          $('video').forEach(el => {
            el.load();

            el.onplay = () => {
              if (el.requestFullscreen) {
                console.log('requestFullscreen');
                el.requestFullscreen();
              } else if (el.webkitRequestFullscreen) {
                /* Safari */
                console.log('webkitRequestFullscreen');
                el.webkitRequestFullscreen();
              }
            };
          });
        });
        self.getEvents();
        self.getOtherExperiences();
      });
    },
    formatDatetime: function (d) {
      const s = d.toDateString();
      const t = this.formatTime(d);
      return s + ' ' + t;
    },
    formatTime: function (d) {
      let h = d.getHours();
      let m = d.getMinutes();
      if (h < 10) h = '0' + h;
      if (m < 10) m = '0' + m;
      return h + ':' + m;
    },
    getEvents: function () {
      // prende le offerte e le trasforma in eventi mydisco
      const app = this.$app,
            $ = this.$,
            id = this.$route.params.id,
            self = this;
      const events = self.poi.offers || [];

      for (let i in events) {
        events[i].title = events[i].caption;
        events[i].text = events[i].description;
        events[i].subtitle = events[i].datetime_init * 1 ? self.formatDatetime(new Date(events[i].datetime_init * 1)) : '';
        events[i].subtitle += events[i].datetime_end * 1 ? ' / ' + self.formatDatetime(new Date(events[i].datetime_end * 1)) : '';
      }

      self.$setState({
        events: events
      });
    },
    getOtherExperiences: function () {
      const app = this.$app,
            $ = this.$,
            id = this.$route.params.id,
            self = this;
      const url = 'poi/' + id + '/other_experiences';
      myApp.server.get(url).then(OE => {
        for (let i in OE) {
          OE[i].poi = OE[i].poi || id;
          OE[i].title = OE[i].title || '';
        }

        self.$setState({
          otherExperiences: OE
        });
      });
    },
    translateText: function (ev) {
      // Google Key:  AIzaSyB8AY9p2GiPEq4iQ7gNmh5IRqI7MfKyy28 
      const self = this;
      const l = this.$(ev.target).data('lng');
      this.translated = this.translated || {};
      this.translated[l] = !!!this.translated[l];

      for (let i in this.translated) {
        if (i !== l) {
          this.translated[i] = false;
          this.$('.button-translate-' + i).attr('src', 'static/img/flag_' + i + '.png');
        }
      }

      if (this.translated[l]) {
        this.$(ev.target).attr('src', 'static/img/flag_translate.png'); // traduce con Google

        this.$('.build-text').text('I\'m translating ...');
        const url = 'https://translation.googleapis.com/language/translate/v2';
        const data = {
          key: 'AIzaSyB8AY9p2GiPEq4iQ7gNmh5IRqI7MfKyy28',
          target: self.$(ev.target).data('lng'),
          q: this.poi.description || '',
          format: 'text'
        };
        this.$app.request.promise.post(url, data, 'json').then(resp => self.$('.build-text').text(resp.data.data.translations[0].translatedText)).catch(() => {
          self.$('.build-text').text(self.poi.text || '');
        });
      } else {
        this.$(ev.target).attr('src', 'static/img/flag_' + l + '.png'); // torna a originale

        this.$('.build-text').html(this.poi.description || '');
      }
    },

    addToFavorites() {
      const $ = this.$,
            self = this;
      if (!myApp.user.id) return this.$app.panel.open('.panel-left');
      myApp.server.post('imc/favorites/' + this.$route.params.id).then(succ => {
        self.poi.favorite = true;
        self.$setState();
      }).catch(err => {
        console.log(err);
      });
    },

    removeToFavorites: function () {
      const $ = this.$,
            self = this,
            app = this.$app;
      if (!myApp.user.id) return this.$app.panel.open('.panel-left');
      app.dialog.confirm(lng.removeFavoritesMessage.replace('$poi$', self.poi.caption), () => {
        myApp.server.delete('imc/favorites/' + this.$route.params.id).then(succ => {
          self.poi.favorite = false;
          self.$setState();
        }).catch(err => {
          console.log(err);
        });
      });
    },

    imgBrowser(idx) {
      const self = this,
            app = this.$app,
            $ = this.$;
      const photoBrowser = app.photoBrowser.create({
        photos: self.images
      });
      photoBrowser.open(idx);
    },

    share() {
      const self = this,
            app = this.$app,
            $ = this.$;
      let url = 'https://app.infomycity.eu/?x=';
      let qs = '/disco/' + this.poi.id + '/';
      url += encodeURIComponent(qs);

      if (app.device.cordova) {
        const options = {
          message: 'Visit the following link:',
          subject: 'Share link',
          url: url,
          chooserTitle: 'Share link'
        };

        var onSuccess = function (result) {
          console.log("Share completed? " + result.completed);
          console.log("Shared to app: " + result.app); // reimposta dimensione viewport (se pubblicità attiva)
          //window.location.reload();
        };

        var onError = function (msg) {
          console.log("Sharing failed with message: " + msg);
        };

        window.plugins.socialsharing.shareWithOptions(options, onSuccess, onError);
      } else {
        app.dialog.alert('Social share non disponibile.', () => window.open(url));
      }
    }

  },
  data: function () {
    return {
      myCoords: myApp.latlng,
      lng: lng,
      poi: {
        events: [],
        coords: {},
        info: {},
        offers: [],
        videos: [],
        images: []
      },
      events: [],
      otherExperiences: [],
      images: [],
      types: {
        '1': lng.poiLabels.disco,
        '2': 'Finest high club',
        '3': 'Night club',
        '4': 'Loung / cocktail bar',
        '5': lng.poiLabels.caribbean,
        '6': 'Disco bar / pub',
        '11': lng.poiLabels.pub,
        '7': 'Folk / local music',
        '8': 'Show restaurant',
        '9': 'Jazz club',
        '10': lng.poiLabels.vineria
      }
    };
  },
  on: {
    pageBeforeIn: function () {
      this.getPOI();
    }
  },
  id: '77881d38c0',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\n  <div class="page theme-dark"> \n\n    <div class="navbar">\n      <div class="navbar-bg"></div>\n      <div class="navbar-inner sliding">\n        <div class="left">\n          <a href="/" class="link">\n            <i class="icon icon-back"></i>\n            <span class="if-not-md">Back</span>\n          </a>\n        </div>\n        <div class="right">\n          ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.poi.favorite, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n          <a href="#" @click="removeToFavorites">\n            <i class="icon f7-icons">heart_slash</i>\n          </a>\n          ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n          <a href="#" @click="addToFavorites">';
          r += c(ctx_2.lng.addToFavorites, ctx_2);
          r += '</a>\n          ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n          <a href="#" @click="share">\n            <img class="share-icon" src="static/share-white.png" alt=""/>\n          </a>\n        </div>\n      </div>\n    </div>\n\n\n    <div class="page-content page-content-banner">\n\n      <!-- home page -->\n      <div class="build-header row">\n\n        ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.poi.logo, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n        <div class="col-30">\n          <div class="build-logo cover" style="background-image: url(';
          r += c(ctx_2.poi.logo, ctx_2);
          r += ')"></div>\n        </div>\n        <div class="col-70">\n          <div style="display: flex; flex-direction: column; justify-content: space-around; align-items: center; height: 28vw">\n            <div class="build-title">';
          r += c(ctx_2.poi.caption, ctx_2);
          r += '</div>\n            <div class="build-subtitle">';
          r += c(ctx_2.poi.description_short, ctx_2);
          r += '</div>\n          </div>\n        </div>\n        ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n        <div class="col">\n          <div class="build-title">';
          r += c(ctx_2.poi.caption, ctx_2);
          r += '</div>\n          <div class="build-subtitle">';
          r += c(ctx_2.poi.description_short, ctx_2);
          r += '</div>\n        </div>\n        ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n      </div>\n\n      <div class="build-chips">\n        ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.poi.subtypes, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += ' ';
          r += Template7Helpers.if.call(ctx_2, ctx_2, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += ' \n        ';
              r += Template7Helpers.js_if.call(ctx_3, "this != 0", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += ' \n        <span class="badge color-deeporange" style="margin-top:3px;">';
                  r += Template7Helpers.js.call(ctx_4, "myApp.categories[myApp.detailItemType][this]", {
                    hash: {},
                    data: data_4 || {},
                    fn: function empty() {
                      return '';
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [ctx_3, ctx_2, ctx_1]
                  });
                  r += '</span> \n        ';
                  return r;
                },
                inverse: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n        <div class="badge-lgbt"></div>\n        ';
                  return r;
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '\n        ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += ' ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n        ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.poi.info.filters, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n        ';
          r += Template7Helpers.if.call(ctx_2, ctx_2, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += ' <span class="badge color-deeppurple text-capitalize" style="margin-top:3px;">';
              r += Template7Helpers.js.call(ctx_3, "lng.filters[@key]", {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</span> ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += ' \n        ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' \n      </div>\n\n      <div class="build-body">\n        <div class="build-slideshow">\n          <div class="build-swiper poi-website-swiper swiper-container swiper-init">\n            <div class="swiper-wrapper">\n              ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.poi.video, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n              <!--  <div class="swiper-slide">\n                  <video class="video_cover build-slideshow-slide" \n                         controls webkit-playsinline  preload="metadata"\n                         style="background-image: url(';
          r += c(ctx_2.poi.video, ctx_2);
          r += '/poster)">\n                    <source src="';
          r += c(ctx_2.poi.video, ctx_2);
          r += '" type="video/mp4"> \n                  </video>\n                </div> -->\n              ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n              ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.poi.images, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n              <div class="swiper-slide">\n                <div @click="imgBrowser(';
          r += c(data_2 && data_2.index, ctx_2);
          r += ')" class="contain build-slideshow-slide" style="background-image: url(';
          r += c(ctx_2.url, ctx_2);
          r += ');"></div>\n              </div>\n              ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += ' ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.poi.videos.length, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n              <div class="swiper-slide">\n                <video class="video_cover build-image" \n                       controls webkit-playsinline\n                       style="background-image: url(';
              r += c(ctx_3.poi.videos[0].url, ctx_3);
              r += '/poster)">\n                  <source src="';
              r += c(ctx_3.poi.videos[0].url, ctx_3);
              r += '" type="video/mp4"> \n                </video>\n              </div>\n               \n              <div class="swiper-slide">\n                <div class="cover build-slideshow-slide" style="background-image: url(static/demo/disco.jpg);"></div>\n              </div>\n              ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n              ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n            </div>\n          </div>\n        </div>\n\n        <div class="build-images">\n          <div class="row no-gap">\n\n            ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.poi.videos, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <div class="col">\n\n              <video class="video_cover build-image" \n                     controls\n                     style="background-image: url(';
          r += c(ctx_2.url, ctx_2);
          r += '?poster)">\n                <source src="';
          r += c(ctx_2.url, ctx_2);
          r += '" type="video/mp4"> \n              </video>\n\n            </div>\n\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n          </div>\n        </div>\n\n        <!-- CONTACTS ICONS -->\n        <div class="row contact-icons">\n          <div class="col text-align-center">\n            <a href="https://www.google.com/maps/dir/?api=1&destination=';
      r += c(ctx_1.poi.latitude, ctx_1);
      r += ',';
      r += c(ctx_1.poi.longitude, ctx_1);
      r += '" \n               class="external button" target="_system">\n              <i class="f7-icons">placemark</i>\n            </a>\n          </div>\n          ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.poi.phone, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n          <div class="col text-align-center">\n            <a href="tel:';
          r += c(ctx_2.poi.phone_link, ctx_2);
          r += '"  target="_system" class="link external button">\n              <i class="f7-icons">phone</i>\n            </a> \n          </div> \n          ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n          ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.poi.web, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n          <div class="col text-align-center"> \n            <a href="';
          r += c(ctx_2.poi.web, ctx_2);
          r += '"  target="_system" class="button link external">\n              <i class="f7-icons">globe</i> \n            </a>\n          </div> \n          ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n          ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.poi.fb, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n          <div class="col text-align-center">  \n            <a href="';
          r += c(ctx_2.poi.fb, ctx_2);
          r += '"  target="_system" class="button link external">\n              <i class="f7-icons">logo_facebook</i>\n            </a>  \n          </div> \n          ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n          ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.poi.instagram, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n          <div class="col text-align-center">  \n            <a href="';
          r += c(ctx_2.poi.instagram, ctx_2);
          r += '"  target="_system" class="button link external">\n              <i class="f7-icons">logo_instagram</i>\n            </a>  \n          </div> \n          ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n        </div>\n\n        <!-- TRANSLATE -->\n        <hr>\n        <div class=\'translate-group\'>\n          <img @click="translateText" data-lng=\'en\' class="button-translate button-translate-en" src="static/img/flag_en.png" alt=""/>\n          <img @click="translateText" data-lng=\'fr\' class="button-translate button-translate-fr" src="static/img/flag_fr.png" alt=""/>\n          <img @click="translateText" data-lng=\'it\' class="button-translate button-translate-it" src="static/img/flag_it.png" alt=""/>\n          <img @click="translateText" data-lng=\'es\' class="button-translate button-translate-es" src="static/img/flag_es.png" alt=""/>\n          <img @click="translateText" data-lng=\'de\' class="button-translate button-translate-de" src="static/img/flag_de.png" alt=""/>\n        </div>\n\n        <!-- TEXT -->\n        <div  class="build-text">';
      r += c(ctx_1.poi.description, ctx_1);
      r += '</div>\n\n        <!-- OTHER EXPERIENCES -->\n        ';
      r += Template7Helpers.js_if.call(ctx_1, "this.otherExperiences.length > 0", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n        <h1 class="other-experiences-title">Other Experiences</h1>\n        <div class="build-events">\n          ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.otherExperiences, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n          <div class="card card-event" @click="goToOtherExperience(\'';
              r += c(ctx_3.id, ctx_3);
              r += '\')">\n            <div class="card-content">\n              <div class="card-event-header">\n                <h2>';
              r += c(ctx_3.title, ctx_3);
              r += '</h2>\n              </div>\n              <div class="cover" style="height: 300px; background-image: url(';
              r += c(ctx_3.images[0], ctx_3);
              r += ');"></div>\n            </div>\n          </div> \n          ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n        </div>\n        ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n        <!-- EVENTS -->\n        ';
      r += Template7Helpers.js_if.call(ctx_1, "this.events.length > 0", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n        <div class="build-whats-on">\n          <h1 class="other-experiences-title">What\'s on</h1>\n        </div>\n        <div class="build-events">\n          ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.events, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n          <div @click="goToEvent(\'';
              r += c(ctx_3.id, ctx_3);
              r += '\')" class="card card-event">\n            <div class="card-content">\n              <div class="card-event-header">\n                <small style="opacity: 0.7">';
              r += c(ctx_3.subtitle, ctx_3);
              r += '</small>\n                <h2>';
              r += c(ctx_3.title, ctx_3);
              r += '</h2>\n              </div>\n              <div class="cover" style="height: 300px; background-image: url(';
              r += c(ctx_3.images[0], ctx_3);
              r += ');"></div>\n              <div class="card-content-padding">\n                <div class="event-desciption">';
              r += c(ctx_3.description_short, ctx_3);
              r += '</div>\n              </div>\n            </div>\n          </div>\n          ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n        </div>\n        ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n        <!-- MENU -->\n        ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.poi.info.menu, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n        <a href="/menu1/';
          r += c(ctx_2.poi.id, ctx_2);
          r += '/" class="button button-fill button-round button-large margin-horizontal margin-bottom text-color-imc">\n          <i class="icon f7-icons icon-small">doc_richtext</i>\n          ';
          r += c(ctx_2.lng.priceListServices, ctx_2);
          r += '\n        </a>\n        ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n        <!-- CONTACTS -->\n        <div class="poi-website-contacts">\n          <p>\n            <a href="https://www.google.com/maps/dir/?api=1&destination=';
      r += c(ctx_1.poi.latitude, ctx_1);
      r += ',';
      r += c(ctx_1.poi.longitude, ctx_1);
      r += '" \n               class="external button" target="_system">\n              <i class="f7-icons" style="font-size: 14px">placemark</i> &nbsp;\n              ';
      r += c(ctx_1.poi.address, ctx_1);
      r += '\n              ';
      r += c(ctx_1.poi.city, ctx_1);
      r += '\n            </a>\n          </p>\n\n          ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.poi.phone, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n          <p>\n            <a href="tel:';
          r += c(ctx_2.poi.phone, ctx_2);
          r += '"  target="_system" class="link external button">\n              <i class="f7-icons" style="font-size: 14px">phone</i>  &nbsp;\n              ';
          r += c(ctx_2.poi.phone, ctx_2);
          r += '\n            </a>\n          </p>\n          ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' \n\n          ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.poi.web, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n          <p>\n            <a href="';
          r += c(ctx_2.poi.web, ctx_2);
          r += '" class="button link external"  target="_system">\n              <i class="f7-icons" style="font-size: 14px">globe</i>  &nbsp;\n              ';
          r += c(ctx_2.poi.web, ctx_2);
          r += '\n            </a>\n          </p>\n          ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n          ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.poi.fb, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n          <p>\n            <a href="';
          r += c(ctx_2.poi.fb, ctx_2);
          r += '" class="button"  class="button link external"  target="_system">\n              <i class="f7-icons" style="font-size: 14px">logo_facebook</i>  &nbsp;\n              ';
          r += c(ctx_2.poi.fb, ctx_2);
          r += '\n            </a>\n          </p>\n          ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n          ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.poi.instagram, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n          <p>\n            <a href="';
          r += c(ctx_2.poi.instagram, ctx_2);
          r += '" class="button"  class="button link external"  target="_system">\n              <i class="f7-icons" style="font-size: 14px">logo_instagram</i>  &nbsp;\n              ';
          r += c(ctx_2.poi.instagram, ctx_2);
          r += '\n            </a>\n          </p>\n          ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n        </div>\n\n        <!-- orario di apertura -->\n        ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.poi.info.opening, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n        <div class=\'margin-left\'>\n          <h4 class="mb-0">';
          r += c(ctx_2.lng.open, ctx_2);
          r += ':</h4>\n          <table class="table-light">\n            ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.poi.info.opening, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n            <tr>\n              <td>';
              r += Template7Helpers.js.call(ctx_3, "lng.weekdays[@index]", {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += ': </td>\n              <td> ';
              r += c(ctx_3.morning, ctx_3);
              r += ' </td>\n              <td> ';
              r += c(ctx_3.evening, ctx_3);
              r += ' </td>\n            </tr>\n            ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n          </table>\n        </div>\n        ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n\n        <div style="height: 120px"></div>\n\n      </div>\n\n\n      <div id="detail-buttons-bottom-group">\n        <a href="/menu/';
      r += c(ctx_1.poi.id, ctx_1);
      r += '/?booking=1"\n           class="link popup-close button button-large button-fill button-round bg-color-imc text-color-white button-booking-fixed">\n          ';
      r += c(ctx_1.lng.book, ctx_1);
      r += '\n          <img width="22" src="static/check.png" alt=""/>\n        </a>\n        <a href="/chat/';
      r += c(ctx_1.poi.id, ctx_1);
      r += '/" \n           class="button button-large button-fill button-round bg-color-primary text-color-imc button-chat-fixed">\n          <i class="icon f7-icons button-fixed-chat ios-only">chat_bubble_text_fill</i>\n          <i class="icon material-icons button-fixed-chat md-only">chat</i>\n        </a>\n      </div>\n\n    </div>\n\n  </div>\n';
      return r;
    }(this);
  },

  styleScoped: false
};
    